import axios from 'axios'
import Swal from 'sweetalert2'

export const baseDomain = process.env.VUE_APP_BACKEND_URL
// export const baseDomain = 'http://localhost:4030'
// export const baseDomain = 'https://labcli-debug.herokuapp.com'

const baseURL = `${baseDomain}/api/v1` // Incase of /api/v1;

// ALL DEFUALT CONFIGURATION HERE
const user = JSON.parse(localStorage.getItem('user'))
const accessToken = user ? user.token : null

const client = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${accessToken}`,
  },
})

// Global handler: when any request returns 401, clear the stored session,
// show an expiration toast and redirect to the login page.
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('user')
      Swal.fire({
        icon: 'error',
        title: 'Sesión expirada',
        text: 'vuelve a iniciar sesión',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      })
      setTimeout(() => {
        location.replace('/')
      }, 2100)
    }
    return Promise.reject(error)
  }
)

export default client
